import { EventProduct, ProductType } from 'types/Products';
import ProductInformation from '../Sections/ProductInformation';
import RelatedProducts from '../Sections/RelatedProducts';
import { YoutubeVideo } from './YoutubeVideo';
const IngredientPageUXB = ({ product }: { product: EventProduct }) => {
  return (
    <>
      {product.event?.product_private_attributes?.data?.video && (
        <YoutubeVideo
          productName={product.name}
          youtubeLink={product.event?.product_private_attributes?.data.video[0]}
        />
      )}
      <ProductInformation product={product} />

      {product.company?.key &&
        product.event.key &&
        (product.type === ProductType.INGREDIENTS ||
          product.type === ProductType.FORMULATIONS) && (
          <RelatedProducts
            productType={product.type}
            companyKey={product.company.key}
            productKey={product.event.key}
          />
        )}
    </>
  );
};

export default IngredientPageUXB;
